module.exports = __webpack_public_path__ + "img/GoDrCanEnergy@2x.0142db4b.png";